@if (alertInconsistencia === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="imagem" src="/assets/img/inconsistencia.png" width="72px" alt="Inconsistencia na pagina">
      <p class="titulo-alert">Ops, algo deu errado</p>
      <!-- Caso de erro só na parte de dados ou endereço -->
      <div>
        <p class="subtitulo-alert">A importação do arquivo foi realizada porém com algumas inconsistências. Clique em reparar ou voltar para cancelar o processo.</p>
      </div>
      <div class="div-botoes">
        <button class="botao me-3" (click)="irParaTratativas()"
        [tag]="addTagManagerInteraction('box:button:click', 'reparar')">REPARAR</button>
        <button class="botao-outline" (click)="fecharAlertInconsistencia()"
        [tag]="addTagManagerInteraction('box:button:click', 'voltar')">VOLTAR</button>
      </div>
    </div>
  </div>
}